import { render, staticRenderFns } from "./RequestLookup.vue?vue&type=template&id=47d6f3b1&scoped=true"
import script from "./RequestLookup.vue?vue&type=script&lang=js"
export * from "./RequestLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6f3b1",
  null
  
)

export default component.exports